import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index';
import mobileRoute from './mobileRoute'
import pcRoute from './pcRoute'
Vue.use(Router);
let agent = navigator.userAgent;
let arr = ['Android','iphone'];
for (let i in arr){
  if(agent.indexOf(arr[i])>=0){
    store.dispatch("setIsMobile",true);
  }
}
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: store.getters.getIsMobile?mobileRoute:pcRoute,
  /*routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/!* webpackChunkName: "about" *!/ './views/About.vue')
    }
  ]*/
})
